import React from 'react'

const Footer = () => {
    return (
        <footer className="footer">
            <div className="footer-icons">
                <a
                    href="#"
                    target="_blank"
                    rel="noopener noreferrer"
                    aria-label="Facebook"
                >
                    <i className="bi bi-facebook"></i>
                </a>
                <a
                    href="#"
                    target="_blank"
                    rel="noopener noreferrer"
                    aria-label="Instagram"
                >
                    <i className="bi bi-instagram"></i>
                </a>
                <a
                    href="#"
                    target="_blank"
                    rel="noopener noreferrer"
                    aria-label="LinkedIn"
                >
                    <i className="bi bi-linkedin"></i>
                </a>
            </div>

            <p className="footer-text">
                All rights reserved. Royal Rugs © 2026. All designs are protected under international copyright laws.
            </p>
        </footer>
    )
}

export default Footer